export const AppConstats = {
  DefaultPath: "/",
  DateFormat: "dd-MM-yyyy",
  DataTimeFormat: "dd-MM-yyyy HH:mm",
  DateTimeUtcFormat: "dd-MM-yyyyTHH:mm:ssZ",
  Jwt: {
    "AccessTokenKey": "access_token",
    "RefreshTokenKey": "refresh_token"
  },
  DefaultPageSize: 20,
  AllowedPageSizes: [20, 50, 100, 200]
}
